import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getAllZorDocuments } from '@/actions/zor-document/getAllZorDocuments';
import { ApiResponse } from '@/types/response.type';
import { ZorDocument } from '@/types/zor.document.type';

export interface UseGetAllZorDocumentsReturn {
  result: ApiResponse<Array<ZorDocument>> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetAllZorDocuments = (): UseGetAllZorDocumentsReturn => {
  const query: UseQueryResult<
    ApiResponse<Array<ZorDocument>> | undefined,
    Error
  > = useQuery({
    queryKey: ['zor-documents'],
    queryFn: getAllZorDocuments,
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
